
function User() {

    return (
        <div style={{ backgroundColor: "yellow", width: "200px", height: "100px" }}>
            jksldjafkl
        </div>
    )
}
export default User;